import React from 'react';
import ExtendedModulePage from './ExtendedModulePage';
export default function ClassTeacherAssignmentsPage(){ return <ExtendedModulePage moduleKey="class-teacher-assignments"/>; }
